<template>
  <div id="user-app-prizes">
    <div class="prizes-title layout-spacing-big">
      <span class="subtitle">Nagradna igra</span>
      <div class="prizes-title-options">
        <div class="survey">
          <span class="icon-bell" v-bind:class="{ 'icon-bell-notification': eventsAvailableForSurvey.length !== 0 }">
            <img src="@/assets/app-icons/home/prize-bar/bell.svg" alt="bell" @click="openNotificationsModal" />
          </span>

          <NotificationsModal
            v-if="isNotificationsModalVisible"
            @close="closeNotificationsModal"
            v-bind:notifications="eventsAvailableForSurvey"
            v-on:openSurveyModal="openSurveyModal($event)"
          />

          <SurveyModal
            v-if="isSurveyModalVisible"
            @close="closeSurveyModal"
            v-bind:event="eventForModal"
            v-bind:surveyData="surveyData"
            v-on:submitSurvey="submitSurvey"
          />
        </div>
      </div>
    </div>
    <div class="layout-spacing">
      <PrizesCodes v-if="features.codes" @onAddedAchievement="handleAddedAchievement" />
      <Achievements v-if="features.achievements" :achievementIdsToAdd="achievementIdsToAdd" />
      <Rewards v-if="features.rewards" />
    </div>
  </div>
</template>

<script>
import SurveyModal from '@/components/app/SurveyModal.vue';
import NotificationsModal from '@/components/app/NotificationsModal.vue';
import Router from '../../../src/router.js';
import PrizesCodes from './Prizes/PrizesCodes';
import Achievements from './Prizes/Achievements';
import Rewards from './Prizes/Rewards';

export default {
  name: 'Prizes',
  components: {
    SurveyModal,
    NotificationsModal,
    PrizesCodes,
    Achievements,
    Rewards,
  },
  data() {
    return {
      eventsAvailableForSurvey: [],
      achievementIdsToAdd: [],
      isNotificationsModalVisible: false,
      isSurveyModalVisible: false,
      eventForModal: {},
      route: 'app/prizes',
      features: { codes: true },
      showPage: true,
      surveyData: [],
    };
  },
  methods: {
    openNotificationsModal() {
      this.isNotificationsModalVisible = true;
      document.getElementsByTagName('body')[0].style.overflowY = 'hidden';
    },
    closeNotificationsModal() {
      this.isNotificationsModalVisible = false;
      document.getElementsByTagName('body')[0].style.overflowY = 'scroll';
    },
    openSurveyModal: function (event) {
      this.eventForModal = event;
      this.isNotificationsModalVisible = false;
      this.isSurveyModalVisible = true;
      document.getElementsByTagName('body')[0].style.overflowY = 'hidden';
    },
    closeSurveyModal() {
      this.isSurveyModalVisible = false;
      this.isNotificationsModalVisible = true;
      document.getElementsByTagName('body')[0].style.overflowY = 'scroll';
    },
    submitSurvey: function () {
      const eventId = this.eventForModal.id;
      const surveyData = this.surveyData;

      if (surveyData.filter(el => el === 0 || el.length === 0).length !== 0) {
        alert('Moraš ispuniti sve ocjene!');
        return;
      }

      this.$axios
        .post(`${this.$API_URL}/user/submit-survey`, {
          eventId: eventId,
          surveyData: surveyData,
        })
        .then(response => {
          this.isNotificationsModalVisible = false;
          this.isSurveyModalVisible = false;
          this.eventsAvailableForSurvey.splice(
            this.eventsAvailableForSurvey.findIndex(event => event.id === eventId),
            1,
          );
          this.points += response.data;
          this.pointsAdded = response.data;
          setTimeout(() => (this.pointsAdded = 0), 3000);
        })
        .catch(() => {
          alert('Slanje ankete nije uspjelo (možda nemaš dopuštenje). Molimo te pokušaj ponovo.');
        });
    },
    handleAddedAchievement: function (achievementIds) {
      this.achievementIdsToAdd = achievementIds;
      this.$axios.get(`${this.$API_URL}/user/available-surveys`).then(response => {
        this.eventsAvailableForSurvey = response.data;
      });
    },
  },
  created() {
    this.$axios.get(`${this.$API_URL}/features/route`, { params: { route: this.route } }).then(response => {
      this.features = response.data.features.reduce((acc, x) => {
        acc[x.path.replace(`${this.route}/`, '')] = x.isActive;

        return acc;
      }, {});
    });
    this.$axios.get(`${this.$API_URL}/features/route`, { params: { route: 'app/navigation' } }).then(response => {
      if (!response.data.features.find(f => f.path === 'app/navigation/prizes').isActive) {
        Router.push('/app');
      }
    });
    this.$axios.get(`${this.$API_URL}/user/available-surveys`).then(response => {
      this.eventsAvailableForSurvey = response.data;
    });
  },
};
</script>

<style scoped>
#user-app-prizes {
  padding: 48px 24px 100px;
}
.popup-title {
  font-weight: bold;
  font-size: 20px;
  margin-right: 16px;
}

.prizes-title {
  font-style: normal;
  font-weight: 800;
  font-size: 32px;
  line-height: 38px;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  margin-bottom: 102px;
}

@media screen and (min-width: 1023px) {
  .prizes-title {
    margin-bottom: 48px;
  }
}

.prizes-title-options {
  display: flex;
  align-items: center;
}

.icon-bell {
  position: relative;
  cursor: pointer;
}

.icon-bell img {
  height: 30px;
}

.icon-bell-notification::after {
  content: '';
  position: absolute;
  top: 1.3px;
  left: 18.7px;
  width: 8px;
  height: 8px;
  background-color: #d73246;
  border-radius: 50%;
}

.close {
  position: relative;
  cursor: pointer;
}

@media screen and (max-width: 1024px) {
  .ddays-logo {
    position: absolute;
    display: block;
    right: 7%;
    top: 83px;
  }
}

@media screen and (max-width: 375px) {
  .popup-title,
  .popup-points {
    font-size: 14px;
  }
}

@media screen and (min-width: 1024px) {
  #user-app-prizes {
    padding: 160px 100px;
  }
}
</style>
